import { render } from "./ConsultaStatus.vue?vue&type=template&id=5d86db7f&scoped=true"
import script from "./ConsultaStatus.vue?vue&type=script&lang=js"
export * from "./ConsultaStatus.vue?vue&type=script&lang=js"

import "./ConsultaStatus.vue?vue&type=style&index=0&id=5d86db7f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d86db7f"]])

export default __exports__